import DesignConstants from "./DesignConstants";

export interface CreationFlowColorConfig {
    primary: string;
    primaryLight: string;
    primaryLightPastel: string;
}

export enum CreationModes {
    TEST = "TEST",
    RECURRING_TASK = "RECURRING_TASK",
}

export const getCreationMode = (creatingMode: CreationModes | ""): CreationModes => {
    switch (creatingMode) {
        case CreationModes.RECURRING_TASK:
            return CreationModes.RECURRING_TASK;
        case CreationModes.TEST:
        default:
            return CreationModes.TEST;
    }
};

export const creationFlowColors: Record<CreationModes, CreationFlowColorConfig> = {
    [CreationModes.TEST]: {
        primary: DesignConstants.COLORS.P6_ORANGE,
        primaryLight: DesignConstants.COLORS.P6_ORANGE_LIGHT_25,
        primaryLightPastel: DesignConstants.COLORS.P6_ORANGE_LIGHT_PASTEL,
    },
    [CreationModes.RECURRING_TASK]: {
        primary: DesignConstants.COLORS.FOREST_GREEN_800,
        primaryLight: DesignConstants.COLORS.FOREST_GREEN_LIGHT_25,
        primaryLightPastel: DesignConstants.COLORS.FOREST_GREEN_PASTEL,
    },
};
